import React from 'react';
import useSnapshotWithFallback from '../hooks/useSnapshotWithFallback';

const CachedSnapshot = ({ 
  cameraId, 
  refreshKey = 0, 
  alt = 'Camera Snapshot',
  className = '',
  showLoadingIndicator = true,
  showCacheIndicator = false,
  options = {}
}) => {
  const { src, loading, failed } = useSnapshotWithFallback(cameraId, refreshKey, options);

  if (loading && !src) {
    return (
      <div className={`bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center ${className}`}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto mb-2"></div>
          <p className="text-xs text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (src && !failed) {
    return (
      <div className={`relative ${className}`}>
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
          onError={() => console.error('Failed to load cached snapshot')}
          style={{ imageRendering: 'auto' }}
        />
        
        {/* Cache indicator */}
        {showCacheIndicator && (
          <div className="absolute top-1 right-1 bg-yellow-500 text-white text-xs px-1 py-0.5 rounded opacity-75">
            Cached
          </div>
        )}
        
        {/* Loading indicator overlay */}
        {showLoadingIndicator && loading && (
          <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
            <div className="bg-white bg-opacity-90 rounded-lg px-3 py-2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mx-auto mb-1"></div>
              <p className="text-xs text-gray-600">Updating...</p>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center ${className}`}>
      <div className="text-center">
        <div className="text-4xl mb-2">📹</div>
        <p className="text-sm text-gray-500">Snapshot unavailable</p>
      </div>
    </div>
  );
};

export default CachedSnapshot;
